import ViewTagsModal from './viewTagsModal';

export default ViewTagsModal;
